import type { SearchItemEntity } from '@iconik-io/shared-lib/src/redux/entities/normalized/search_item';

import ICONS from '../../icons/constants';
import Icon from '../../icons/icon';
import TooltipTrigger from '../tooltip_trigger/tooltip_trigger';

import styles from './search_warning_sign.module.css';

type Props = {
  item: SearchItemEntity;
};

export function SearchWarningSign({ item }: Props) {
  return (
    <TooltipTrigger
      placement="top"
      component={Icon}
      tooltipText={item.warning}
      componentProps={{
        icon: ICONS.Warning,
        className: styles.warning_icon,
        size: 24,
      }}
    />
  );
}
